export const getCandidateRecruitersOptions = candidateData => {
  if (!candidateData || candidateData?.additionalRecruiters?.length === 0) return [];

  const formattedAccountable = {
    id: candidateData?.recruiter?.id,
    fullName: candidateData?.recruiter?.personalInformation?.full_name
  };

  const formattedAdditionalRecruiters = candidateData?.additionalRecruiters
    .map(item => ({
      id: item.recruiter?.id,
      fullName: item.recruiter?.personalInformation?.full_name
    }))
    .filter(item => item.id !== formattedAccountable.id);

  return [formattedAccountable, ...formattedAdditionalRecruiters];
};
